<script>
import { base } from "@/components/Tools/FormHelper/Helper/mixins";
import { getSnippet } from "@/components/Tools/FormHelper/Helper/functions";

export default {
  mixins: [base],
  methods: {
    getSnippet(text) {
      return getSnippet(text, this.options.snippetPrefix);
    }
  }
};
</script>

<template>
  <label class="col-form-label">{{ getSnippet(field.label) }}</label>
</template>
